import React, { useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../store/indexRedux";
import { useRoles } from "../hooks/useRoles";
import { getSessionFromCookie } from "../components/utils/cognito";
import axios from "axios";
import { toast } from "react-toastify";
import { PendingToast } from "../components/ui/toastResponds/PendingToast";

const DeletePvCurtailment: React.FC = () => {
  const [pvId, setPvId] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const user = useSelector((state: RootState) => state.user);
  const { isAdmin } = useRoles();

  console.log(user);

  const handleDelete = async () => {
    if (!pvId.trim()) {
      toast.error(<PendingToast title="Error" message="Please enter a PV Curtailment ID" />, {
        position: "bottom-right",
        autoClose: 3000,
      });
      return;
    }

    const toastId = toast.info(<PendingToast title="Deleting" message="Deleting PV Curtailment..." />, {
      position: "bottom-right",
      autoClose: false,
    });

    setIsDeleting(true);

    try {
      const session = getSessionFromCookie();
      const token = session?.getAccessToken().getJwtToken();

      if (!token) {
        throw new Error("Authentication token is required");
      }

      const apiUrl = `${import.meta.env.VITE_API_SERVICES || "http://localhost:8001"}/api/v1/sdp/pvcurtailment/${pvId}`;

      await axios.delete(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      toast.dismiss(toastId);
      toast.success(<PendingToast title="Success" message={`PV Curtailment ${pvId} deleted successfully!`} />, {
        position: "bottom-right",
        autoClose: 3000,
      });

      // Clear the input field
      setPvId("");
    } catch (error) {
      toast.dismiss(toastId);

      const errorMessage = axios.isAxiosError(error)
        ? error.response?.data?.message || error.message
        : "Failed to delete PV Curtailment";

      toast.error(<PendingToast title="Error" message={errorMessage} />, {
        position: "bottom-right",
        autoClose: 5000,
      });
    } finally {
      setIsDeleting(false);
    }
  };

  if (!isAdmin) {
    return (
      <div style={{ padding: "2rem", textAlign: "center" }}>
        <h1 style={{ color: "#e74c3c" }}>Access Denied</h1>
        <p>You must be an administrator to access this page.</p>
      </div>
    );
  }

  return (
    <div style={{ padding: "2rem", maxWidth: "600px", margin: "0 auto" }}>
      <h1 style={{ marginBottom: "1.5rem" }}>Delete PV Curtailment</h1>

      <div style={{ marginBottom: "1rem" }}>
        <label htmlFor="pvId" style={{ display: "block", marginBottom: "0.5rem", fontWeight: "500" }}>
          PV Curtailment ID
        </label>
        <input
          id="pvId"
          type="text"
          value={pvId}
          onChange={(e) => setPvId(e.target.value)}
          placeholder="e.g., PV-AAF"
          disabled={isDeleting}
          style={{
            width: "100%",
            padding: "0.75rem",
            fontSize: "1rem",
            border: "1px solid #ccc",
            borderRadius: "4px",
            boxSizing: "border-box",
          }}
        />
      </div>

      <button
        onClick={handleDelete}
        disabled={isDeleting || !pvId.trim()}
        style={{
          width: "100%",
          padding: "0.75rem",
          fontSize: "1rem",
          fontWeight: "600",
          color: "#fff",
          backgroundColor: isDeleting || !pvId.trim() ? "#ccc" : "#e74c3c",
          border: "none",
          borderRadius: "4px",
          cursor: isDeleting || !pvId.trim() ? "not-allowed" : "pointer",
          transition: "background-color 0.2s",
        }}
        onMouseEnter={(e) => {
          if (!isDeleting && pvId.trim()) {
            e.currentTarget.style.backgroundColor = "#c0392b";
          }
        }}
        onMouseLeave={(e) => {
          if (!isDeleting && pvId.trim()) {
            e.currentTarget.style.backgroundColor = "#e74c3c";
          }
        }}
      >
        {isDeleting ? "Deleting..." : "Delete PV Curtailment"}
      </button>

      <div style={{ marginTop: "1.5rem", padding: "1rem", backgroundColor: "#fff3cd", borderRadius: "4px" }}>
        <p style={{ margin: 0, fontSize: "0.9rem", color: "#856404" }}>
          <strong>Warning:</strong> This action cannot be undone. Please make sure you enter the correct ID.
        </p>
      </div>
    </div>
  );
};

export default DeletePvCurtailment;
